(function () {
  'use strict';
  // iOS WebKit never fires beforeunload, so the theme's page-transition cover
  // stays hidden there and the fixed bottom bar rides the browser toolbar
  // while the next page loads. Hide the bar from the tap until the page leaves.
  function isLeavingClick(event, anchor, here) {
    if (event.defaultPrevented || event.button !== 0) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (!anchor || anchor.hasAttribute('download')) return false;
    const target = anchor.getAttribute('target');
    if (target && target !== '_self') return false;
    let url;
    try { url = new URL(anchor.href, here.href); } catch (e) { return false; }
    if (url.origin !== here.origin || !/^https?:$/.test(url.protocol)) return false;
    return url.pathname !== here.pathname || url.search !== here.search;
  }
  const root = document.documentElement;
  let timer;
  function clear() { root.classList.remove('rehair-leaving'); clearTimeout(timer); }
  // Window bubble phase runs after theme/app handlers, so their preventDefault is visible.
  window.addEventListener('click', event => {
    const anchor = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!isLeavingClick(event, anchor, window.location)) return;
    root.classList.add('rehair-leaving');
    clearTimeout(timer);
    timer = setTimeout(clear, 8000);
  });
  // Back/forward cache restores the old page; show the bar again.
  window.addEventListener('pageshow', clear);
})();
